(ns scittle.clara-rules
  {:no-doc true}
  (:require [scittle.core :as scittle]
            [sci.core :as sci]
    [clara.rules]))

;; Plugin: clara-rules
;; Generated by build.clj

(defn init []
  (scittle/register-plugin!
   ::clara-rules
   {:namespaces
   {'clara.rules (sci/copy-ns clara.rules (sci/create-ns 'clara.rules nil))}}
   ))
